import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Box, Grid, Link, Typography } from '../../utils/material-ui-core';

const TermsConditions = () => {
  const pageStyles = LocalPageStyles();

  return (
    <Grid container spacing={3}>
      <Grid item zeroMinWidth>
        <Box display="flex" justifyItems="center" alignItems="center" style={{ height: '25px' }}>
          <Typography variant="body2" component="div">
            <Box p={1} className={pageStyles.copyright}>
              ©2024 HSB. All Rights Reserved.
            </Box>
          </Typography>
        </Box>
      </Grid>
      <Grid item zeroMinWidth>
        <Box p={1} display="flex" justifyItems="center" alignItems="center" style={{ height: '25px', paddingTop: '7px' }}>
          <Link
            component="button"
            variant="body2"
            className={pageStyles.terms}
            onClick={() => {

            }}
          >
            Privacy
          </Link>

          <Box className={pageStyles.copyright}>&nbsp;|&nbsp;</Box>

          <Link
            component="button"
            variant="body2"
            className={pageStyles.terms}
            onClick={() => {

            }}
          >
            Terms of Service
          </Link>
        </Box>
      </Grid>
    </Grid>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    copyright: {
      color: "#999999",
      fontWeight: "normal",
    },
    terms: {
      color: "#999999",
      fontWeight: "normal",
    },
  })
);

export default TermsConditions;
